import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
// import DialogActions from '@mui/material/DialogActions';
// import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
// import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
// import { ContactSupportRounded } from '@mui/icons-material';
import {
  CircularProgress, Container, Stack,
} from '@mui/material';
// import Colors from '../../../Configs/colors';

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

export default function ModalBase({
  open,
  handleClose,
  handleAgree,
  classes,
  cancelText,
  confirmText,
  maxWidth,
  children,
  noAgree,
  noCancel,
  isLoading,
  fullWidth,
  smallBtn,
  disabled,
}) {
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      maxWidth={maxWidth || 'sm'}
      fullWidth={fullWidth}
    >
      <div className={classes.root}>
        <Container>
          {/* <DialogTitle>{title}</DialogTitle> */}
          <div className="weight-700 mt-2">
            {children}
          </div>
          <div className="mt-3">
            <Stack direction="row" container spacing={2} justifyContent="space-between">
              {!noCancel
              && (
              <Button
                fullWidth={!smallBtn}
                size="large"
                variant="outlined"
                className="btn-outlined"
                onClick={handleClose}
                sx={{ px: 6 }}
              >
                {cancelText || 'Cancel'}
              </Button>
              )}
              {!noAgree
                && (
                  <Button
                    fullWidth={!smallBtn}
                    size="large"
                    variant="contained"
                    className="btn-contained"
                    onClick={handleAgree}
                    startIcon={isLoading && (<CircularProgress size={16} sx={{ mr: 1, color: '#fff' }} />)}
                    sx={{ px: 6 }}
                    disabled={disabled}
                  >
                    {confirmText || 'Confirm'}
                  </Button>
                )}
            </Stack>
          </div>
        </Container>
      </div>
    </Dialog>
  );
}
